const DEFAULT_API_BASE_URL = 'https://timeglobe-server.ecomtask.de/api';

const stripTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const joinWithPath = (base: string, path: string) => {
  const normalizedBase = stripTrailingSlash(base);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
};

const resolveApiBaseUrl = (): string => {
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  if (envUrl && envUrl.trim().length > 0) {
    return stripTrailingSlash(envUrl.trim());
  }

  return DEFAULT_API_BASE_URL;
};

export const API_BASE_URL = resolveApiBaseUrl();
export const AUTH_API_BASE_URL = joinWithPath(API_BASE_URL, '/auth');

/**
 * Login, token renewal and logout go through the page's OWN origin: vercel.json
 * rewrites `/api/*` to the backend (`proxy` in package.json does the same for
 * `npm start`). That makes the session cookie a plain first-party cookie of
 * the dashboard's host. Set by the backend's host directly, Safari would cap
 * it at 7 days (the host is a CNAME to a third party, onrender.com — WebKit's
 * CNAME-cloaking rule) and sign people out after a week away. Everything else
 * keeps calling the backend directly with the access token.
 */
const resolveSessionApiBaseUrl = (): string => {
  const envUrl = process.env.REACT_APP_SESSION_API_BASE_URL;
  if (envUrl && envUrl.trim().length > 0) {
    return stripTrailingSlash(envUrl.trim());
  }

  return '/api/auth';
};

export const SESSION_API_BASE_URL = resolveSessionApiBaseUrl();

